import { Navigate } from "react-router-dom";
import useBusiness from "@/core/business/use-business";
import PostOnboardingItems from "./post-onboarding/post-onboarding-items";
import WaitingPageLayout from "./waiting-page-layout";

const WaitingForPhoneNumber = () => {
  const { selectedBusiness } = useBusiness();

  const isPhoneNumberVerified =
    selectedBusiness && selectedBusiness?.phone_number;

  if (isPhoneNumberVerified) {
    return <Navigate to="/" />;
  }

  return (
    <WaitingPageLayout
      headline="Your referral hotline is almost ready"
      body="We're setting up your new phone number. Our team will be in touch before this page updates."
    >
      <PostOnboardingItems />
    </WaitingPageLayout>
  );
};

export default WaitingForPhoneNumber;
